import { Link } from "react-router-dom";
import { useSettings } from "@/context/AppContext";
import SEO from "@/components/SEO";
import { PageHero, Reveal, SectionHead } from "@/components/Motion";
import { Package, ArrowUpRight } from "lucide-react";

const COLS = [
  { key: "rice", title: "Rice Packaging", link: "/rice" },
  { key: "spices", title: "Spices Packaging", link: "/spices" },
  { key: "tea", title: "Tea Packaging", link: "/tea" },
];

export default function Packaging() {
  const { settings } = useSettings();
  if (!settings) return <div className="min-h-screen bg-parchment" />;
  const pkg = settings.packaging || {};

  return (
    <div data-testid="packaging-page">
      <SEO title="Packaging Options | AnVibes Exports" description="Export packaging options for Indian spices, rice and teas — from retail packs to bulk and custom packaging." path="/packaging" />
      <PageHero eyebrow="Packaging" title="Export-ready packaging, sized to your market." description={pkg.note} image={settings.categories?.spices?.image} />

      <section className="bg-parchment py-20 lg:py-28">
        <div className="mx-auto max-w-[1440px] px-4 sm:px-8 lg:px-16">
          <div className="grid gap-6 lg:grid-cols-3">
            {COLS.map((col, i) => (
              <Reveal key={col.key} delay={i * 0.1}>
                <div className="h-full border border-forest/10 bg-white p-8" data-testid={`packaging-${col.key}`}>
                  <Package className="h-7 w-7 text-gold-dark" />
                  <h3 className="mt-4 font-serif text-2xl text-forest">{col.title}</h3>
                  <ul className="mt-5 space-y-2.5">
                    {(pkg[col.key] || []).map((p) => (
                      <li key={p} className="flex items-center gap-3 border-b border-forest/8 pb-2.5 text-sm text-[#4A554D]">
                        <span className="h-1.5 w-1.5 rounded-full bg-gold" /> {p}
                      </li>
                    ))}
                  </ul>
                  <Link to={col.link} className="mt-6 inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.18em] text-gold-dark hover:text-forest transition-colors">
                    View {col.key} products <ArrowUpRight className="h-3.5 w-3.5" />
                  </Link>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-14 border border-forest/10 bg-white p-8 lg:p-10 flex flex-col lg:flex-row lg:items-center gap-6 justify-between">
            <div>
              <h3 className="font-serif text-2xl text-forest">Need a specific packaging format?</h3>
              <p className="mt-2 text-sm text-[#4A554D] max-w-xl">Custom and private-label packaging requirements can be discussed with our export team. Share your specifications in the quote form.</p>
            </div>
            <Link to="/quote" data-testid="packaging-quote-cta" className="inline-flex shrink-0 items-center gap-2 bg-forest px-7 py-4 text-sm font-semibold uppercase tracking-[0.16em] text-parchment hover:bg-forest-leaf transition-colors">
              Request a Quote
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
